// @generated by protoc-gen-grpc-gateway-es v0.5.0 with parameter "target=ts,generate_name_parser=true"
// @generated from file ai/h2o/mlops/deployer/v2/deployment_service.proto (package ai.h2o.mlops.deployer.v2, syntax proto3)
/* eslint-disable */

import type { Deployment } from "./deployment_pb";
import type { BigIntString } from "../../../../../runtime";
import { RPC } from "../../../../../runtime";
import type { Status } from "../../../../../google/rpc/status_pb";

/**
 * Request message for CreateDeployment
 *
 * @generated from message ai.h2o.mlops.deployer.v2.CreateDeploymentRequest
 */
export type CreateDeploymentRequest = {
/**
 * Required. The resource name of the workspace to create deployment in.
 * Format: `workspaces/{workspace}`
 *
 * @generated from field: string parent = 1;
 */
parent: string;
/**
 * Required. The Deployment resource to create.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.Deployment deployment = 2;
 */
deployment: Deployment;
}
;
/**
 * Response message for CreateDeployment
 *
 * @generated from message ai.h2o.mlops.deployer.v2.CreateDeploymentResponse
 */
export type CreateDeploymentResponse = {
/**
 * The created Deployment.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.Deployment deployment = 1;
 */
deployment?: Deployment;
}
;
/**
 * Request message for ListDeployments
 *
 * @generated from message ai.h2o.mlops.deployer.v2.ListDeploymentsRequest
 */
export type ListDeploymentsRequest = {
/**
 * Required. The resource name of the workspace to list Deployments from.
 * Format: `workspaces/{workspace}`
 * Passing dash `-` as a workspace will list deployments across all workspaces
 * that the user has access to.
 *
 * @generated from field: string parent = 1;
 */
parent: string;
/**
 * Maximum number of items server should return in the response. When set to 0
 * server will decide how many items to return.
 * Server can decide to return less items then specified.
 *
 * @generated from field: int32 page_size = 2;
 */
pageSize?: number;
/**
 * Use value returned in next_page_token to retrieve next page of results.
 *
 * @generated from field: string page_token = 3;
 */
pageToken?: string;
/**
 * When used, server will only return deployment that match the filter.
 * Attempts to generally implement AIP-160 (https://aip.dev/160)
 * specification.
 *
 * Supported fields:
 *   * display_name
 *   * description
 *   * create_time
 *   * update_time
 *   * creator
 *   * deployment_type
 *   * security_type
 *   * monitoring_enabled
 *   * experiment_ids
 *   * deployment_state
 *   * runtimes
 *
 * Examples:
 * display_name = 'Some display' OR create_time <= 2023-12-30T23:59:43Z
 * create_time >= timestamp('2023-12-30T23:59:43Z') AND create_time <= timestamp('2024-03-20T08:00:00Z')
 * NOT(display_name = 'Some display name' OR create_time <= timestamp('2023-12-30T23:59:43Z'))
 * NOT(monitoring_enabled)
 * experiment_ids:c07a4cf2-0733-4419-937d-fdd7b804788e
 * deployment_state = 'FAILED' OR deployment_state = 'UNHEALTHY'
 * runtimes:'workspaces/global/runtimes/my-runtime'
 *
 * @generated from field: string filter = 4;
 */
filter?: string;
/**
 * When used, server will return deployments ordered by the specified fields.
 * Attempts to implement AIP-132 (https://aip.dev/132#ordering).
 *
 * Not every filterable field is sortable, and not every sortable field is
 * filterable: `security_type`, `monitoring_enabled`, `experiment_ids`,
 * `runtimes` and `deployment_state` can be filtered on but not ordered by.
 *
 * Ordered directly by the resource field of the same name:
 *   * display_name
 *   * description
 *   * create_time
 *   * update_time
 *   * creator
 *   * namespace
 *
 * Ordered by a derived value:
 *   * workspace_id: Identifier of the owning workspace. Intended for
 *     listings across all workspaces (`parent` = `workspaces/-`), where it
 *     groups deployments by workspace. When `parent` names a single
 *     workspace every deployment shares the same value, so the sort has no
 *     effect. Orders by the workspace identifier, not by its display name.
 *   * replicas: Number of deployment replicas
 *   * requirements_requests.cpu: CPU requests in millicores
 *   * requirements_requests.memory: Memory requests in bytes
 *   * requirements_limits.cpu: CPU limits in millicores
 *   * requirements_limits.memory: Memory limits in bytes
 *   * deployment_type: Number of deployment elements
 *     (single=1, shadow=2, split=actual element count, min 2)
 *   * name: The full resource name. Sorts lexicographically over
 *     `workspaces/{workspace}/deployments/{deployment}`, so a listing
 *     across all workspaces groups by workspace exactly as `workspace_id`
 *     does. Within a single workspace this is deployment identifier order,
 *     which is stable but arbitrary — use `display_name` to order
 *     alphabetically.
 *
 * Deployments tied on every requested field are ordered by a stable internal
 * key, so repeated queries return them in a consistent order. Results may
 * still shift while paging if deployments are created or deleted
 * concurrently.
 *
 * Examples:
 *   create_time desc
 *   replicas asc, display_name desc
 *   requirements_requests.cpu desc
 *   workspace_id, create_time desc
 *   requirements_requests.cpu desc, replicas desc, deployment_type desc
 *
 * @generated from field: string order_by = 5;
 */
orderBy?: string;
}
;
/**
 * Response message for ListDeployments
 *
 * @generated from message ai.h2o.mlops.deployer.v2.ListDeploymentsResponse
 */
export type ListDeploymentsResponse = {
/**
 * Collection of deployments.
 *
 * @generated from field: repeated ai.h2o.mlops.deployer.v2.Deployment deployments = 1;
 */
deployments?: Deployment[];
/**
 * Used to retrieve the next page of results.
 * When unset, no further items are available (this response was the last page).
 *
 * @generated from field: string next_page_token = 2;
 */
nextPageToken?: string;
}
;
/**
 * Request message for CountDeployments
 *
 * @generated from message ai.h2o.mlops.deployer.v2.CountDeploymentsRequest
 */
export type CountDeploymentsRequest = {
/**
 * Required. The resource name of the workspace to count Deployments from.
 * Format: `workspaces/{workspace}`
 *
 * @generated from field: string parent = 1;
 */
parent: string;
/**
 * When used, server will only count deployments that match the filter.
 * Attempts to generally implement AIP-160 (https://aip.dev/160)
 * specification.
 *
 * Supported fields:
 *   * display_name
 *   * description
 *   * create_time
 *   * update_time
 *   * creator
 *   * deployment_type
 *   * security_type
 *   * monitoring_enabled
 *   * experiment_ids
 *   * deployment_state
 *   * runtimes
 *
 * Examples:
 * display_name = 'Some display' OR create_time <= 2023-12-30T23:59:43Z
 * create_time >= timestamp('2023-12-30T23:59:43Z') AND create_time <= timestamp('2024-03-20T08:00:00Z')
 * NOT(display_name = 'Some display name' OR create_time <= timestamp('2023-12-30T23:59:43Z'))
 * NOT(monitoring_enabled)
 * experiment_ids:c07a4cf2-0733-4419-937d-fdd7b804788e
 * deployment_state = 'FAILED' OR deployment_state = 'UNHEALTHY'
 * runtimes:'workspaces/global/runtimes/my-runtime'
 *
 * @generated from field: string filter = 2;
 */
filter?: string;
}
;
/**
 * Response message for CountDeployments
 *
 * @generated from message ai.h2o.mlops.deployer.v2.CountDeploymentsResponse
 */
export type CountDeploymentsResponse = {
/**
 * Number of deployments.
 *
 * @generated from field: int64 count = 1;
 */
count?: BigIntString;
}
;
/**
 * The request message for getting an deployment.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.GetDeploymentRequest
 */
export type GetDeploymentRequest = {
/**
 * The name of the deployment to get, in the form:
 * "workspaces/{workspace}/deployment/{deployment}"
 *
 * @generated from field: string name = 1;
 */
name: string;
}
;
/**
 * The response message for getting an deployment.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.GetDeploymentResponse
 */
export type GetDeploymentResponse = {
/**
 * The retrieved deployment.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.Deployment deployment = 1;
 */
deployment?: Deployment;
}
;
/**
 * The request message for updating a deployment.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.UpdateDeploymentRequest
 */
export type UpdateDeploymentRequest = {
/**
 * The deployment to update.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.Deployment deployment = 1;
 */
deployment: Deployment;
/**
 * The fields to update.  An empty value, or value of `*`, implies all
 * updatable fields should apply.
 *
 * The following fields are supported:
 * `display_name`
 * `description`
 * `deployment.kubernetes_resource_spec`
 * `deployment.kubernetes_config_shortcut`
 * `deployment.security` (deprecated singular; only usable on deployments with 0 or 1 security entries)
 * `deployment.securities` (wholesale replace of the repeated list)
 * `deployment.securities.<id>` (per-entry replace if the body carries a matching entry, delete otherwise)
 * `deployment.securities.+<N>` (insert N new entries; the body must contain exactly N entries with empty id)
 * `deployment.monitoring`
 * `deployment.environment_variables`
 * `deployment.cors`
 * `deployment.vpa_spec`
 * `deployment.pod_disruption_budget`
 * `deployment.external.proxy_url.upstream_url` (proxy_url mode only;
 * triggers proxy pod restart)
 * `deployment.external.proxy_url.upstream_auth` (proxy_url mode only;
 * triggers proxy pod restart)
 * Granular `deployment.securities.<id>` and `deployment.securities.+<N>` paths
 * may be combined in a single request; mixing them with the wholesale
 * `deployment.securities` path is rejected. See Security.id for full
 * per-entry update semantics.
 * Allowed security updates are:
 * - no security -> plain_text/hash/token_auth
 * - plain_text -> hash
 * - hash -> plain_text
 * - old plain_text -> new plain_text
 * - old hash -> new hash
 * - plain_text -> token_auth
 * - hash -> token_auth
 * - token_auth -> plain_text
 * - token_auth -> hash
 * All other cases would be ignored and updated passphrase hash must not be blank.
 *
 * @generated from field: google.protobuf.FieldMask update_mask = 2;
 */
updateMask?: string;
}
;
/**
 * The response message for updating a deployment.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.UpdateDeploymentResponse
 */
export type UpdateDeploymentResponse = {
/**
 * The updated deployment.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.Deployment deployment = 1;
 */
deployment?: Deployment;
}
;
/**
 * Request message for DeleteDeployment
 * (-- api-linter: core::0135::force-field=disabled
 *     aip.dev/not-precedent: Child schedule row is deleted via ON DELETE CASCADE. --)
 *
 * @generated from message ai.h2o.mlops.deployer.v2.DeleteDeploymentRequest
 */
export type DeleteDeploymentRequest = {
/**
 * Required. Deployment resource name.
 * Format: workspaces/{workspace}/deployments/{deployment}
 *
 * @generated from field: string name = 1;
 */
name: string;
}
;
/**
 * Response message for DeleteDeployment
 *
 * @generated from message ai.h2o.mlops.deployer.v2.DeleteDeploymentResponse
 */
export type DeleteDeploymentResponse = {
}
;
/**
 * Request message for RetryDeployment
 *
 * @generated from message ai.h2o.mlops.deployer.v2.RetryDeploymentRequest
 */
export type RetryDeploymentRequest = {
/**
 * Required. Deployment resource name.
 * Format: workspaces/{workspace}/deployments/{deployment}
 *
 * @generated from field: string name = 1;
 */
name: string;
}
;
/**
 * Response message for RetryDeployment
 *
 * @generated from message ai.h2o.mlops.deployer.v2.RetryDeploymentResponse
 */
export type RetryDeploymentResponse = {
}
;
/**
 * Request message for UpdateRuntimeImage
 *
 * @generated from message ai.h2o.mlops.deployer.v2.UpgradeRuntimeImageRequest
 */
export type UpgradeRuntimeImageRequest = {
/**
 * Required. Deployment resource name.
 * Format: workspaces/{workspace}/deployments/{deployment}
 *
 * @generated from field: string name = 1;
 */
name: string;
/**
 * Optional. List of runtime image updates to apply to specific deployment compositions.
 * Each target specifies an experiment_id and the new runtime_image to apply to that composition.
 * If empty, all compositions in the deployment will be upgraded to the latest compatible
 * runtime image version for each composition's runtime independently (e.g., a DAI Mojo
 * composition gets the latest DAI Mojo runtime image, while a H2O-3 composition gets
 * the latest H2O-3 runtime image).
 *
 * @generated from field: repeated ai.h2o.mlops.deployer.v2.RuntimeImageTarget targets = 2;
 */
targets?: RuntimeImageTarget[];
}
;
/**
 * Specifies a runtime image update for a specific deployment composition identified by experiment_id.
 * This allows targeting individual compositions within split, shadow, or single deployments.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.RuntimeImageTarget
 */
export type RuntimeImageTarget = {
/**
 * Optional. The resource name of the RuntimeImageVersion to upgrade to.
 * If not provided, it will be resolved and populated by the system to the latest available
 * version compatible with the composition's runtime (based on the composition's current
 * runtime image).
 * Format: `workspaces/{workspace}/runtimeImages/{runtime_image}/versions/{version}`.
 *
 * @generated from field: string runtime_image_version = 1;
 */
runtimeImageVersion?: string;
/**
 * ID of the experiment linked to deployment composition.
 * Used to identify which deployment composition(s) to update. Matches against
 * DeploymentComposition.experiment_id in single, shadow (primary/secondary),
 * or split elements.
 *
 * @generated from field: string experiment_id = 2;
 */
experimentId: string;
}
;
/**
 * Response message for UpdateRuntimeImage
 *
 * @generated from message ai.h2o.mlops.deployer.v2.UpgradeRuntimeImageResponse
 */
export type UpgradeRuntimeImageResponse = {
/**
 * The updated deployment.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.Deployment deployment = 1;
 */
deployment?: Deployment;
}
;
/**
 * Request message for PauseDeployment
 *
 * @generated from message ai.h2o.mlops.deployer.v2.PauseDeploymentRequest
 */
export type PauseDeploymentRequest = {
/**
 * Required. Deployment resource name.
 * Format: workspaces/{workspace}/deployments/{deployment}
 *
 * @generated from field: string name = 1;
 */
name: string;
}
;
/**
 * Response message for PauseDeployment
 *
 * @generated from message ai.h2o.mlops.deployer.v2.PauseDeploymentResponse
 */
export type PauseDeploymentResponse = {
}
;
/**
 * Request message for ResumeDeployment
 *
 * @generated from message ai.h2o.mlops.deployer.v2.ResumeDeploymentRequest
 */
export type ResumeDeploymentRequest = {
/**
 * Required. Deployment resource name.
 * Format: workspaces/{workspace}/deployments/{deployment}
 *
 * @generated from field: string name = 1;
 */
name: string;
}
;
/**
 * Response message for ResumeDeployment
 *
 * @generated from message ai.h2o.mlops.deployer.v2.ResumeDeploymentResponse
 */
export type ResumeDeploymentResponse = {
}
;
/**
 * Request message for DeleteDeploymentMonitoring
 * (-- api-linter: core::0135::force-field=disabled
 *     aip.dev/not-precedent: This is a custom RPC that clears monitoring data, not a resource deletion — force semantics do not apply. --)
 *
 * @generated from message ai.h2o.mlops.deployer.v2.DeleteDeploymentMonitoringRequest
 */
export type DeleteDeploymentMonitoringRequest = {
/**
 * Required. Deployment resource name.
 * Format: workspaces/{workspace}/deployments/{deployment}
 *
 * @generated from field: string name = 1;
 */
name: string;
}
;
/**
 * Response message for DeleteDeploymentMonitoring
 *
 * @generated from message ai.h2o.mlops.deployer.v2.DeleteDeploymentMonitoringResponse
 */
export type DeleteDeploymentMonitoringResponse = {
}
;
/**
 * Request message for BatchUpgradeRuntimeImage
 *
 * @generated from message ai.h2o.mlops.deployer.v2.BatchUpgradeRuntimeImageRequest
 */
export type BatchUpgradeRuntimeImageRequest = {
/**
 * Required. The resource name of the workspace containing the deployments.
 * All deployment names must belong to this workspace.
 * Format: `workspaces/{workspace}`
 *
 * @generated from field: string parent = 1;
 */
parent: string;
/**
 * Required. List of deployment upgrade specifications.
 * Each entry specifies a deployment and optionally a runtime image version.
 * Must contain at least 1 entry. Maximum 1000 entries allowed.
 *
 * @generated from field: repeated ai.h2o.mlops.deployer.v2.UpgradeRuntimeImageRequest requests = 2;
 */
requests: UpgradeRuntimeImageRequest[];
}
;
/**
 * Response message for BatchUpgradeRuntimeImage
 *
 * @generated from message ai.h2o.mlops.deployer.v2.BatchUpgradeRuntimeImageResponse
 */
export type BatchUpgradeRuntimeImageResponse = {
/**
 * Successfully upgraded deployments.
 * Contains the updated Deployment resources.
 *
 * @generated from field: repeated ai.h2o.mlops.deployer.v2.Deployment deployments = 1;
 */
deployments?: Deployment[];
/**
 * Errors encountered for specific deployments.
 * Key is the deployment name from the request.
 * Value contains the error status (code and message).
 *
 * @generated from field: map<string, google.rpc.Status> errors = 2;
 */
errors?: { [key: string]: Status };
}
;
/**
 * Creates a deployment.
 *
 * @generated from rpc ai.h2o.mlops.deployer.v2.DeploymentService.CreateDeployment
 */
export const DeploymentService_CreateDeployment = new RPC<CreateDeploymentRequest,CreateDeploymentResponse>("POST", "/v2/{parent=workspaces/*}/deployments", "deployment");
/**
 * Returns a collection of Deployments within a workspace.
 *
 * @generated from rpc ai.h2o.mlops.deployer.v2.DeploymentService.ListDeployments
 */
export const DeploymentService_ListDeployments = new RPC<ListDeploymentsRequest,ListDeploymentsResponse>("GET", "/v2/{parent=workspaces/*}/deployments");
/**
 * Returns the number of Deployments within a workspace.
 *
 * @generated from rpc ai.h2o.mlops.deployer.v2.DeploymentService.CountDeployments
 */
export const DeploymentService_CountDeployments = new RPC<CountDeploymentsRequest,CountDeploymentsResponse>("GET", "/v2/{parent=workspaces/*}/deployments:count");
/**
 * Retrieves a single deployment.
 *
 * @generated from rpc ai.h2o.mlops.deployer.v2.DeploymentService.GetDeployment
 */
export const DeploymentService_GetDeployment = new RPC<GetDeploymentRequest,GetDeploymentResponse>("GET", "/v2/{name=workspaces/*/deployments/*}");
/**
 * Updates a deployment.
 *
 * @generated from rpc ai.h2o.mlops.deployer.v2.DeploymentService.UpdateDeployment
 */
export const DeploymentService_UpdateDeployment = new RPC<UpdateDeploymentRequest,UpdateDeploymentResponse>("PATCH", "/v2/{deployment.name=workspaces/*/deployments/*}", "deployment");
/**
 * Deletes a deployment.
 *
 * @generated from rpc ai.h2o.mlops.deployer.v2.DeploymentService.DeleteDeployment
 */
export const DeploymentService_DeleteDeployment = new RPC<DeleteDeploymentRequest,DeleteDeploymentResponse>("DELETE", "/v2/{name=workspaces/*/deployments/*}");
/**
 * Retry failed deployment.
 *
 * @generated from rpc ai.h2o.mlops.deployer.v2.DeploymentService.RetryDeployment
 */
export const DeploymentService_RetryDeployment = new RPC<RetryDeploymentRequest,RetryDeploymentResponse>("POST", "/v2/{name=workspaces/*/deployments/*}:retry");
/**
 * Update runtime image used in deployment
 * Caller requires 'actions/mlops/deployments/UPGRADE_RUNTIME_IMAGE' permission.
 *
 * @generated from rpc ai.h2o.mlops.deployer.v2.DeploymentService.UpgradeRuntimeImage
 */
export const DeploymentService_UpgradeRuntimeImage = new RPC<UpgradeRuntimeImageRequest,UpgradeRuntimeImageResponse>("POST", "/v2/{name=workspaces/*/deployments/*}:upgradeRuntimeImage");
/**
 * Batch update runtime images for multiple deployments.
 * Upgrades ALL compositions within each specified deployment to the latest (or specified) runtime image version.
 * Caller requires 'actions/mlops/deployments/UPGRADE_RUNTIME_IMAGE' permission.
 *
 * @generated from rpc ai.h2o.mlops.deployer.v2.DeploymentService.BatchUpgradeRuntimeImage
 */
export const DeploymentService_BatchUpgradeRuntimeImage = new RPC<BatchUpgradeRuntimeImageRequest,BatchUpgradeRuntimeImageResponse>("POST", "/v2/{parent=workspaces/*}/deployments:batchUpgradeRuntimeImage");
/**
 * Pause a deployment by scaling all elements to 0 replicas.
 * Delegates to UpdateDeployment with replicas=0, then scales the Kubernetes
 * workload to 0 directly — a deployment whose replica count was set by a
 * schedule or on-demand engine is not covered by the update alone. Saves
 * current replica counts so ResumeDeployment can restore them, and suspends
 * scheduling for the duration of the pause.
 * Applies to every deployment type. Where the replica count lives differs:
 * external deployments scale their proxy down through
 * `deployment.external.replicas` instead of
 * `deployment.kubernetes_resource_spec`, and ResumeDeployment restores it by
 * the same ladder.
 * Returns Internal if the Kubernetes scale-down could not be applied; the
 * pause remains in effect and the call may be retried.
 * Caller requires 'actions/mlops/deployments/PAUSE' permission.
 *
 * @generated from rpc ai.h2o.mlops.deployer.v2.DeploymentService.PauseDeployment
 */
export const DeploymentService_PauseDeployment = new RPC<PauseDeploymentRequest,PauseDeploymentResponse>("POST", "/v2/{name=workspaces/*/deployments/*}:pause");
/**
 * Resume a paused deployment by restoring replica counts saved by
 * PauseDeployment. Delegates to UpdateDeployment.
 * Resuming a deployment that is not at replicas=0 is an idempotent no-op:
 * the pause flags are cleared and OK is returned.
 * When previous_replicas is absent (e.g. deployment was zeroed via
 * UpdateDeployment directly, or a transient DB error occurred during pause),
 * restores to 1 replica as a safe default. Exception: a deployment configured
 * with 0 replicas and an enabled schedule or on-demand config resumes to 0 —
 * that engine owns the replica count and scales it up (a scheduled window, or
 * the first request under on-demand).
 * Caller requires 'actions/mlops/deployments/RESUME' permission.
 *
 * @generated from rpc ai.h2o.mlops.deployer.v2.DeploymentService.ResumeDeployment
 */
export const DeploymentService_ResumeDeployment = new RPC<ResumeDeploymentRequest,ResumeDeploymentResponse>("POST", "/v2/{name=workspaces/*/deployments/*}:resume");
/**
 * Delete monitoring data related to deployment
 *
 * @generated from rpc ai.h2o.mlops.deployer.v2.DeploymentService.DeleteDeploymentMonitoring
 */
export const DeploymentService_DeleteDeploymentMonitoring = new RPC<DeleteDeploymentMonitoringRequest,DeleteDeploymentMonitoringResponse>("DELETE", "/v2/{name=workspaces/*/deployments/*}:deleteDeploymentMonitoring");
